import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "posthog-js/react";
import { capturePageView } from "../analytics";
import { rememberEntry, trackPageView } from "../visitorTracking";

let lastTrackedLocationKey: string | null = null;
let lastTrackedUrl: string | null = null;

export const PageViewTracker = () => {
  const location = useLocation();
  const posthog = usePostHog();

  useEffect(() => {
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const locationKey = location.key || null;

    if (
      locationKey &&
      locationKey === lastTrackedLocationKey &&
      currentUrl === lastTrackedUrl
    ) {
      return;
    }

    lastTrackedLocationKey = locationKey;
    lastTrackedUrl = currentUrl;

    // Where this tab came from, for the inquiry form (no cookie, no id).
    rememberEntry();

    capturePageView(posthog, {
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      title: document.title,
      url: window.location.href,
    });

    // First-party visitor tracking (only records with analytics consent).
    trackPageView(window.location.pathname);
  }, [
    location.hash,
    location.key,
    location.pathname,
    location.search,
    posthog,
  ]);

  return null;
};
